// extracted by mini-css-extract-plugin
module.exports = {"friendRequestsCard":"FriendRequests_friendRequestsCard___pHDP"};